<template>
    <div class="main-box">
        <div class="sub-title">
          <p>{{info.title}}<span v-show="info.des" @click="tooltip(info.des)" class="mark-q"><van-icon name="question-o" /></span></p>
        </div>
        <table>
          <tr v-for="(ele,index) in data" :key="index">
            <td class="index">{{index+1}}</td>
            <td class="company-name">{{ele.company_name}}</td>
            <td class="value">{{priceTrans(ele.total_price)}}万元</td>
          </tr>
        </table>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
export default {
    name: "customerData",
  components: {
  },
  props:{
    info:{
      type:Object,
      default:function(){
        return {
          title:'订单总金额前十',
          des:'',
          name:'totalPrice',
          limit:10,
          sale:'E',
          askData:"railwayCustomer"
        }
      }
    },
  },
  data() {
    return {
      active: 0,
      data:[]
    };
  },
  computed: {},
  methods: {
    link: function(value) {
      location.href = "/" + value;
    },
    chooseOne(value){
      this.$emit('clickMark',value);
    },
    priceTrans(value){
      return (parseFloat(value)/10000).toFixed(1).toString();
    },
    getQuantity() {
      this.$axios
        .post(this.$url + "/statistics", {
          userToken: userToken,
          askData: this.info.askData,
          info:this.info
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.data = response.data.res_record;
          } else {
            this.$toast(response.data.error_info);
          }
        })
        .catch(error => {
          this.$toast("网络无法连接或" + error);
        });
    },
    tooltip(value){
      this.$toast(value);
    }
  },
  created() {
      this.getQuantity();
  }
    
}
</script>
<style scoped>

.main-box{
  padding: 0 0.5rem 0.8rem;
  font-size:0.6rem;
}
.sub-title{
  text-align: center;
  font-size: 0.7rem;
  padding-bottom:0.7rem; 
  font-family: 'KaiTi';
  font-weight:600;
}
table{
  width:100%;
}
td{
  border-bottom:1px solid #eee;
  padding: 0.3rem 0;
}

tr:last-child td{
  border: none;
}

.index{
  display:table-cell;
  vertical-align: middle;
  width:5%;
}

.company-name{
  width:70%;
}

.value{
  display:table-cell;
  text-align: right;
  vertical-align: middle;
}

.mark-q{
  position: relative;
  top:0.1rem;
}


</style>